import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=72dc335b&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=ts"
export * from "./BasicInformation.vue?vue&type=script&lang=ts"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=72dc335b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc335b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72dc335b')) {
      api.createRecord('72dc335b', component.options)
    } else {
      api.reload('72dc335b', component.options)
    }
    module.hot.accept("./BasicInformation.vue?vue&type=template&id=72dc335b&scoped=true", function () {
      api.rerender('72dc335b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/BasicInformation.vue"
export default component.exports